import styled from 'styled-components';

import {
  BodyStandardRegular,
  BodyStandardSemiBold,
  Colour,
} from '@xemplo/style-constants';

export const Container = styled.div`
  display: flex;
  padding: 0 8px 32px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;

export const TextMessage = styled.p`
  ${BodyStandardRegular};
  color: ${Colour.Clarity.Content.Medium};

  .countdown {
    ${BodyStandardSemiBold};
  }
`;
